<div class="top-page-component d-none d-md-block">
  <mat-icon (click)="scrollToTop()" [ngClass]="{'display-icon':windowScrolled}" class="fixed-bottom-right">
    arrow_circle_up
  </mat-icon>
</div>
